import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            id: {
                translation: {
                    rent_luxury_car: "Sewa Mobil Mewah",
                    without_hassle: "Tanpa Ribet",
                    desc_hero_section: "Rasakan kenyamanan perjalanan dengan mobil premium pilihan kami. Booking cepat dan harga terbaik untuk pengalaman tak terlupakan.",
                    view_unit: "Lihat Unit",
                    contact_us: "Hubungi Kami",
                    unit: "Unit",
                    harga: "Harga",
                    testimoni: "Testimoni",
                    kontak: "Kontak",
                    pesan_sekarang: "Pesan Sekarang",
                    kirim: "Kirim",
                    chat_hello: "👋 Halo! Ada yang bisa kami bantu?",
                    we_are_online: "Kami sedang Online",
                    chat_whatsapp: "Chat kami di WhatsApp",
                    daily: "Harian",
                    weekly: "Mingguan",
                    monthly: "Bulanan",
                    info_service: "Informasi Layanan Kami",                                    
                    rent_daily_weekley: "Sewa Harian & Mingguan",
                    desc_rent_daily_weekley: "Nikmati Kemudahan perjalanan dengan layanan sewa mobil harian dan mingguan. Cocok untuk liburan, perjalanan bisnis, atau keperluan pribadi anda di Medan dengan harga yang fleksibel dan terjangkau.",
                    driver_pro: "Supir Profesional",
                    desc_driver_pro: "Tidak perlu khawatir soal arah jalan atau kenyamanan perjalanan, karena kami menyediakan supir berpengalaman, ramah, dan profesional yang siap mengantar Anda ke tujuan dengan aman.",
                    units: "Unit Mobil Lengkap",
                    desc_units: "Dari city car, MVP, hingga kendaraan premium, kami menyediakan pilihan unit mobil lengkap yang bisa disesuaikan dengan kebutuhan perjalanan Anda. Semua armada selalu dirawat agar tetap prima",
                    ready_to_airport: "Antar Jemput Bandara",
                    desc_ready_to_airport: "Nikmati layanan antar jemput bandara yang praktis, tepat waktu, dan nyaman. Perjalanan Anda dari atau menuju bandara jadi lebih tenang tanpa harus repot mencari transportasi",
                    available_units: "Unit Tersedia",
                    loading_units: "Memuat data unit...",
                    list_prices: "Daftar Harga Sewa Unit",
                    loading_prices: "Memuat data harga...",
                    label_address: "Alamat Kami",
                    label_telp: "Telp",
                    operating_hours :"Jam Operasional",
                    operating_hours_weekdaty: "Senin - Jumat: 24 Jam Online",//08.00 - 21.00
                    operating_hours_saturday: "Sabtu: 24 Jam Online",
                    operating_hours_sunday: "Minggu & Libur: Tutup",
                    the_said_about_us: "Apa Kata Pelanggan",
                    label_tour: "Jasa Manajemen Tour",
                    desc_tour: "Kami tetap menyediakan jasa tours namun sesuai dengan transformasi bisnis yang kami terapkan. untuk jasa tour kami menyediakan jasa manajemen dimana bagi para pelanggan kami yang ingin berwisata kemanapun di Sumatera Utara. kami dapat menyusun paket tour yang disesuaikan dengan keinginan pelanggan kami. Dengan fokus pada penyediaan sarana transportasi dan pengemudi serta bekerjasama dengan jaringan Tour and Travel yang selama ini telah bersama sama membangun industri pariwisata di Sumatera Utara. Kami yakin dapat memberikan kepuasan yang maksimal bagi para pelanggan.",
                    tour_1_title: "Tur Internasional & Lokal",
                    tour_2_title: "Perjalanan Grup & Korporat",
                    tour_3_title: "Itinerary Khusus",
                    tour_4_title: "Koordinasi Acara & Perjalanan",
                    tour_1_desc: "Paket tur terorganisir yang mencakup destinasi lokal populer dan perjalanan internasional dengan fasilitas lengkap.",
                    tour_2_desc: "Manajemen perjalanan yang disesuaikan untuk perusahaan, sekolah, dan komunitas dengan jadwal serta pengaturan yang fleksibel.",
                    tour_3_desc: "Kebebasan untuk membuat rencana perjalanan sesuai preferensi Anda — destinasi, akomodasi, dan aktivitas.",
                    tour_4_desc: "Dukungan manajemen lengkap untuk acara, ibadah, outing, dan agenda wisata dengan koordinasi profesional."

                }
            },
            en: {
                translation: {
                    rent_luxury_car: "Rent Luxury Cars",
                    without_hassle: "Without Hassle",
                    desc_hero_section: "Experience the comfort of travel with our selected premium cars. Quick booking and the best prices for an unforgettable experience.",
                    view_unit: "View Unit",
                    contact_us: "Contact Us",
                    unit: "Unit",
                    harga: "Price",
                    testimoni: "Testimonials",
                    kontak: "Contact",
                    pesan_sekarang: "Order Now",
                    kirim: "Send",
                    chat_hello: "👋 Hello! How can we help you?",
                    we_are_online: "We Are Online",
                    chat_whatsapp: "Chat with us on WhatsApp",
                    daily: "Daily",
                    weekly: "Weekly",
                    monthly: "Monthly",
                    info_service: "Our Service Information",
                    rent_daily_weekley: "Daily & Weekly Rental",
                    desc_rent_daily_weekley: "Enjoy hassle-free travel with our daily and weekly car rental service. Perfect for holidays, business trips, or personal needs in Medan with flexible and affordable rates.",
                    driver_pro: "Professional Driver",
                    desc_driver_pro: "No need to worry about directions or comfort, as we provide experienced, friendly, and professional drivers ready to take you safely to your destination.",
                    units: "Complete Car Units",
                    desc_units: "From city cars and MPVs to premium vehicles, we offer a complete selection of cars tailored to your travel needs. All our fleets are well-maintained to ensure top performance.",
                    ready_to_airport: "Airport Pickup & Drop-off",
                    desc_ready_to_airport: "Enjoy a practical, punctual, and comfortable airport transfer service. Your journey to or from the airport becomes more relaxed without the hassle of finding transportation.",
                    available_units: "Available Units",
                    loading_units: "Loading Units...",
                    list_prices: "Rental Price List",
                    loading_prices: "Loading Prices...",
                    label_address: "Address",
                    label_telp: "Telp",
                    operating_hours :"Operating Hours",
                    operating_hours_weekdaty: "Monday – Friday: 24 Jam Online",//08:00 – 21:00
                    operating_hours_saturday: "Saturday: 24 Jam Online",//08:00 – 17:00
                    operating_hours_sunday: "Sunday & Public Holidays: Closed",
                    the_said_about_us: "What Our Customers Say",
                    label_tour: "Tour Management Services",
                    desc_tour: "We continue to provide tour services in line with the business transformation we are implementing. For our tour services, we offer tour management for customers who wish to travel anywhere in North Sumatra. We can design customized tour packages tailored to our customers’ preferences. With a focus on providing transportation and drivers, as well as collaborating with our network of Tour and Travel partners who have long been contributing to the tourism industry in North Sumatra, we are confident in delivering maximum satisfaction to our customers.",
                    tour_1_title: "International & Local Tours",
                    tour_2_title: "Group & Corporate Travel",
                    tour_3_title: "Custom Itinerary",
                    tour_4_title: "Event & Trip Coordination",
                    tour_1_desc: "Organized tour packages covering popular local destinations and international trips with complete facilities.",
                    tour_2_desc: "Tailored travel management for companies, schools, and communities with flexible schedules and arrangements.",
                    tour_3_desc: "Freedom to create travel plans according to your preferences — destinations, accommodation, and activities.",
                    tour_4_desc: "Complete management support for events, pilgrimages, outings, and tourism agendas with professional coordination.",
                }
            },
        },
        fallbackLng: "id",
        interpolation: { escapeValue: false }
    });

export default i18n;
